// import * as types from "./actionTypes";

export const GET_ALL_CATEGORIES = 'GET_ALL_CATEGORIES';
export const CATEGORY_SELECTED = 'CATEGORY_SELECTED';

export function categorySelected(category) {
  return { type: CATEGORY_SELECTED, category };
}
